import * as constants from "../constants";

export interface UpdateModalSizeAction {
    data: { size: string };
    type: constants.UPDATE_MODAL_SIZE | constants.SWITCH_MODAL_SIZE;
}

export function updateModalSize(data: { size: string }): UpdateModalSizeAction {
    return {
        data,
        type: constants.UPDATE_MODAL_SIZE,
    };
}
